import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA37zsDZUIkbYrkVj_vpIU0K7PxNBUHoQ4",
  authDomain: "jaybel-dev.firebaseapp.com",
  projectId: "jaybel-dev",
  storageBucket: "jaybel-dev.firebasestorage.app",
  messagingSenderId: "115724636423",
  appId: "1:115724636423:web:054326c1e63e032d9bf5a2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Messaging
export const messaging = getMessaging(app);

// VAPID
export const VAPID_KEY = "BH_U9d3wL9XvJwOZvWlSSy_arUd6xdVuISCdOSpZgG_QaPxNdo_AandmnGGuBFnY3k_IW_RGZm3K7_OnK_3ncRc";

export default app;
